import UpgradeIndex, { upgradeloader, upgradeaction } from './index';
//import CryptoDeposit from './Crypto';
//import Crypto from './Crypto';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import af from './style.module.scss';

function Upgrade() {
  return (
    <div>
      <div className={af.body}>
        <Outlet />
      </div>
    </div>
  );
}
//    { index: true, element: <AddFundsIndex /> },

export const upgraderoutes = {
  path: `upgrade`,
  //loader: mostrloader(apiContext),
  element: <Upgrade />,
  children: [
    { index: true, element: <UpgradeIndex />, action: upgradeaction, loader: upgradeloader },
    /*{
      path: 'crypto',
      element: <CryptoDeposit />,
      //loader: contactLoader,
    },*/
  ],
};
